import type { StatusBadgeProps } from "@/components/ds/StatusBadge";

type Tone = NonNullable<StatusBadgeProps["tone"]>;

// Fallback categories (also fetched live from the API).
export const FALLBACK_CATEGORIES: { value: string; label: string }[] = [
  { value: "business_overview", label: "Business overview" },
  { value: "services", label: "Services" },
  { value: "pricing_guidance", label: "Pricing guidance" },
  { value: "service_areas", label: "Service areas" },
  { value: "hours", label: "Hours" },
  { value: "faq", label: "Frequently asked questions" },
  { value: "policies", label: "Policies" },
  { value: "financing", label: "Financing" },
  { value: "promotions", label: "Promotions" },
  { value: "emergency_procedures", label: "Emergency procedures" },
  { value: "staff_departments", label: "Staff and departments" },
  { value: "custom", label: "Custom" },
];

export const STATUS_META: Record<string, { label: string; tone: Tone }> = {
  draft: { label: "Draft", tone: "amber" },
  approved: { label: "Approved", tone: "green" },
  archived: { label: "Archived", tone: "slate" },
};

// Document processing lifecycle — honest labels; "uploaded" is NOT AI-ready.
export const DOC_STATUS_META: Record<string, { label: string; tone: Tone }> = {
  uploaded: { label: "Uploaded", tone: "slate" },
  processing: { label: "Processing", tone: "amber" },
  ready: { label: "Ready for AI", tone: "green" },
  failed: { label: "Failed", tone: "red" },
};

export function catLabel(value: string): string {
  return FALLBACK_CATEGORIES.find((c) => c.value === value)?.label ?? value;
}

export function fmtDate(iso?: string | null): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

export function fmtSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
